import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=b4aba468&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aba468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4aba468')) {
      api.createRecord('b4aba468', component.options)
    } else {
      api.reload('b4aba468', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=b4aba468&scoped=true&", function () {
      api.rerender('b4aba468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2euXTcGnVa99s/JS/comp/Voucher-Unit.vue"
export default component.exports